﻿interface ILocaleInfo {
    calendar?: {
        shortDayNames?: string[],
        fullDayNames?: string[],
        shortMonthNames?: string[],
        fullMonthNames?: string[],
        firstDayOfWeek?:number,//0 is sundary
    },
    datePicker: {
        format?: string
    }
}
const defaultLocaleInfo: ILocaleInfo = {
    calendar: {
        shortDayNames: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        fullDayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        shortMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        fullMonthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        firstDayOfWeek:0
    },
    datePicker: {
        format:'MM/dd/yyyy'
    }
};

const wd = window as any;

export const localeInfo: ILocaleInfo = {
    ...defaultLocaleInfo,
    ...wd['TUE_LOCALE_INFO']
};